<div class="row">
    <div class="col-sm-3">
        <div class="rating-block">
            <h2 class="bold padding-bottom-7">4.3 <small>Wonderful<br><span class="total_rev">1,234 Reviews</span></small></h2>
        </div>
        <div class="clearfix"></div>
        <div class="rating_bar">
            <div class="pull-left">
                <div class="pull-left" style="width:240px;">
                    <span class="sr-only1">5 - Excellent</span>
                    <div class="progress" style="height:5px; margin:0px 0px 12px 0;">
                      <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="5" aria-valuemin="0" aria-valuemax="5" style="width: 90%">
                      </div>
                    </div>
                </div>
            </div>
            <div class="pull-left">
                <div class="pull-left" style="width:240px;">
                    <span class="sr-only1">4 - Good</span>
                    <div class="progress" style="height:5px; margin:0px 0px 12px 0;">
                      <div class="progress-bar progress-bar-primary" role="progressbar" aria-valuenow="4" aria-valuemin="0" aria-valuemax="5" style="width: 80%">
                      </div>
                    </div>
                </div>
            </div>
            <div class="pull-left">
                <div class="pull-left" style="width:240px;">
                    <span class="sr-only1">3 - Okay</span>
                    <div class="progress" style="height:5px; margin:0px 0px 12px 0;">
                      <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="3" aria-valuemin="0" aria-valuemax="5" style="width: 60%">
                      </div>
                    </div>
                </div>
            </div>
            <div class="pull-left">
                <div class="pull-left" style="width:240px;">
                    <span class="sr-only1">2 - Poor</span>
                    <div class="progress" style="height:5px; margin:0px 0px 12px 0;">
                      <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="2" aria-valuemin="0" aria-valuemax="5" style="width: 40%">
                      </div>
                    </div>
                </div>
            </div>
            <div class="pull-left">
                <div class="pull-left" style="width:240px;">
                    <span class="sr-only1">2 - Terrible</span>
                    <div class="progress" style="height:5px; margin:0px 0px 12px 0;">
                      <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="1" aria-valuemin="0" aria-valuemax="5" style="width: 20%">
                      </div>
                    </div>
                </div>
            </div>
        </div>	
    </div>
    <div class="col-sm-9">
      <div class="review-block">
        <div class="row">
            <div class="col-sm-12">
                <div class="review-block-rate">
                    <h4>5/5 Excellent</h4>
                <div class="review-block-date">10 July 2020</div>
                <div class="review-block-name">Johnny Appleseed</div>
                </div>
                <div class="review-block-title"><i class="fal fa-smile"></i> Liked: Cleanliness, Staff & Service, Room Comfort</div>
                <div class="review-block-description">Got the E-Suite and it was beautiful with stunning views. The only downfall was the elevator situation. 
                    You must go to the 70th floor exit and get a second elevator to your destination floor - but hey, I am sure there is some reason behind it that we aren't aware of. 5 stars - def recommend
                </div>
                <span class="stayed">Stayed 3 Nights in July 2020</span>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-sm-12">
                <div class="review-block-rate">
                    <h4>5/5 Excellent</h4>
                <div class="review-block-date">10 July 2020</div>
                <div class="review-block-name">Johnny Appleseed</div>
                </div>
                <div class="review-block-title"><i class="fal fa-smile"></i> Liked: Cleanliness, Staff & Service, Room Comfort</div>
                <div class="review-block-description">Got the E-Suite and it was beautiful with stunning views. The only downfall was the elevator situation. 
                    You must go to the 70th floor exit and get a second elevator to your destination floor - but hey, I am sure there is some reason behind it that we aren't aware of. 5 stars - def recommend
                </div>
                <span class="stayed">Stayed 3 Nights in July 2020</span>
            </div>
        </div>
        <hr/>
        <a class="more_review">All Reviews</a>
        </div>
        </div>
</div>    
